import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIText1, UIText2, Image } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { buildMortgageBannerUnderPriceIpotekaUrl } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

import * as styles from './NewbuildingMortgageWidgetPromoDiscount.css';
import newBuildingIcon from './assets/newbuilding-promo-ipoteka.png';
import { TMortgageBannerVerticalName, trackMortgageWidgetAnchorClick, trackMortgageWidgetAnchorShow } from './tracking';

interface IUiData {
  linkText: string;
}

const defaultData: IUiData = {
  linkText: 'Ипотека',
};

interface INewbuildingMortgageWidgetPromoDiscountProps {
  mortgagePromoDesign: string | null;
  verticalName: TMortgageBannerVerticalName;
}

export const NewbuildingMortgageWidgetPromoDiscount: React.FC<INewbuildingMortgageWidgetPromoDiscountProps> = ({
  verticalName,
}) => {
  const redirectPath = buildMortgageBannerUnderPriceIpotekaUrl(verticalName);

  const handleAnchorClick = () => {
    trackMortgageWidgetAnchorClick(verticalName);
  };

  return (
    <ActionAfterViewObserver callback={() => trackMortgageWidgetAnchorShow(verticalName)} callbackDelay={1000}>
      <div data-testid="mortgage-widget-promo" className={styles['container']}>
        <a
          href={redirectPath}
          target="_blank"
          rel="noreferrer"
          className={styles['anchor-next']}
          onClick={handleAnchorClick}
        >
          <div className={styles['anchor-icon']}>
            <Image src={newBuildingIcon} alt="logo" objectFit="contain" preloader={false} />
          </div>
          <div className={styles['text']}>
            <UIText1>Циан.Ипотека</UIText1>
            <UIText2 color="text-secondary-default">{defaultData.linkText}</UIText2>
          </div>
          <div className={styles['arrow']}>
            <IconActionChevronRight16 color="icon-main-default" />
          </div>
        </a>
      </div>
    </ActionAfterViewObserver>
  );
};
